/**
 * 会议模块
 */
import { PAGE_LEVEL } from '@/constants';
export default {
  meta: { localeModules: ['meeting', 'meetingRecording', 'recorder', 'roadshow', 'summary'] },
  path: '/self-help',
  redirect: '/self-help/meeting/list',
  children: [
    {
      // 会议列表
      path: 'meeting',
      redirect: 'coming',
      children: [
        {
          path: 'mine',
          name: 'mineMeeting',
          component: () => import(/* webpackChunkName: 'mine-meeting' */ '@/pages/selfhelp/meeting/mine.vue'),
          meta: {
            name: 'routers.meeting_meeting',
            componentName: 'MineMeetingIndex',
            pageLevel: PAGE_LEVEL.FIRST,
            keepAlive: true
          }
        },
        {
          path: 'recordDetail',
          name: 'recordDetail',
          component: () => import(/* webpackChunkName: 'record-detail' */ '@/pages/selfhelp/meeting/recordDetail.vue'),
          meta: {
            name: 'routers.meeting_record_file',
            parent: '/self-help/meeting/mine',
            pageLevel: PAGE_LEVEL.SECOND
          }
        },
        {
          // 即将召开
          path: 'coming',
          name: 'comingMeeting',
          component: () => import(/* webpackChunkName: 'coming-meeting' */ '@/pages/selfhelp/meeting/coming.vue'),
          meta: {
            name: 'routers.meeting_coming',
            componentName: 'MineMeetingIndex',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },
        {
          // 历史会议
          path: 'history',
          name: 'historyMeeting',
          component: () => import(/* webpackChunkName: 'coming-history' */ '@/pages/selfhelp/meeting/history.vue'),
          meta: {
            name: 'routers.meeting_history_meeting',
            componentName: 'HistoryMeetingIndex',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },
        {
          // 我发起的
          path: 'myInitiate',
          name: 'MyInitiateMeeting',
          component: () =>
            import(/* webpackChunkName: 'coming-my-initiate' */ '@/pages/selfhelp/meeting/myInitiate.vue'),
          meta: {
            name: 'routers.meeting_my_initiate',
            componentName: 'MyInitiateMeetingIndex',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },

        {
          path: 'attendingDetails',
          name: 'attendingDetails',
          component: () => import(/* webpackChunkName: 'user-detail' */ '@/pages/selfhelp/meeting/userDetail.vue'),
          meta: {
            pageLevel: PAGE_LEVEL.SECOND,
            name: 'routers.meeting_attending_details',
            parent: '/self-help/meeting/mine',
            otherParent: ['/self-help/meeting/myInitiate', '/self-help/meeting/history']
          }
        },
        {
          path: 'recordingFiles',
          name: 'recordingFiles',
          component: () =>
            import(/* webpackChunkName: 'recording-files' */ '@/pages/selfhelp/meeting/recordingFiles.vue'),
          meta: {
            pageLevel: PAGE_LEVEL.SECOND,
            name: 'routers.meeting_cloud_recording',
            parent: '/self-help/meeting/mine',
            otherParent: ['/self-help/meeting/myInitiate', '/self-help/meeting/history']
          }
        },
        {
          path: 'regular-detail',
          name: 'regularMeetingDetail',
          component: () =>
            import(/* webpackChunkName: 'regular-meeting-detail' */ '@/pages/selfhelp/meeting/regular/detail.vue'),
          meta: {
            name: 'routers.meeting_meeting_detail',
            parent: '/self-help/meeting/mine',
            otherParent: ['/self-help/meeting/myInitiate', '/self-help/meeting/history'],
            noBackground: true,
            pageLevel: PAGE_LEVEL.SECOND
          }
        },
        {
          path: 'history-summary-doc',
          name: 'historySummaryDoc',
          component: () =>
            import(/* webpackChunkName: 'history-summary-doc' */ '@/pages/selfhelp/meeting/historySummaryDoc'),
          meta: {
            name: 'routers.meeting_summary_doc',
            parent: '/self-help/meeting/mine',
            componentName: 'HistorySummaryDoc',
            pageLevel: PAGE_LEVEL.SECOND
          }
        }
      ]
    },
    {
      // 参会审核
      path: 'meeting-check',
      redirect: 'meetingCheckList',
      children: [
        {
          path: 'list',
          name: 'meetingCheckList',
          component: () => import(/* webpackChunkName: 'meeting-check-list' */ '@/pages/selfhelp/check/index.vue'),
          meta: {
            name: 'routers.meeting_meeting_check',
            componentName: 'CheckList',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },
        {
          path: 'detail',
          name: 'meetingCheckDetail',
          component: () => import(/* webpackChunkName: 'meeting-check-detail' */ '@/pages/selfhelp/check/detail.vue'),
          meta: {
            name: 'routers.meeting_application_details',
            parent: '/self-help/meeting/mine',
            pageLevel: PAGE_LEVEL.SECOND
          }
        }
      ]
    },
    {
      // 合规管理
      path: 'meeting',
      redirect: 'meetingCompliance',
      children: [
        {
          // 历史参会
          path: 'compliance/history',
          name: 'HistoryMeetingCompliance',
          component: () =>
            import(
              /* webpackChunkName: 'meeting-compliance-history' */ '@/pages/selfhelp/compliance/historyMeeting.vue'
            ),
          meta: {
            name: 'routers.meeting_history_attending',
            componentName: 'HistoryMeetingComplianceIndex',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },
        {
          // 员工发起
          path: 'compliance/employee',
          name: 'EmployeeInitiateCompliance',
          component: () =>
            import(
              /* webpackChunkName: 'meeting-compliance-list' */ '@/pages/selfhelp/compliance/employeeInitiate.vue'
            ),
          meta: {
            name: 'routers.meeting_employee_initiate',
            componentName: 'EmployeeInitiateComplianceIndex',
            pageLevel: PAGE_LEVEL.FIRST
          }
        },
        {
          path: 'compliance-attending-details',
          name: 'complianceAttendingDetails',
          component: () => import(/* webpackChunkName: 'user-detail' */ '@/pages/selfhelp/meeting/userDetail.vue'),
          meta: {
            name: 'routers.meeting_attending_details',
            parent: '/self-help/meeting/compliance/history',
            otherParent: ['/self-help/meeting/compliance/employee'],
            pageLevel: PAGE_LEVEL.SECOND
          }
        },
        {
          path: 'compliance-regular-detail',
          name: 'complianceMeetingDetail',
          component: () =>
            import(/* webpackChunkName: 'regular-meeting-detail' */ '@/pages/selfhelp/meeting/regular/detail.vue'),
          meta: {
            name: 'routers.meeting_detail',
            parent: '/self-help/meeting/compliance/history',
            otherParent: ['/self-help/meeting/compliance/employee'],
            noBackground: true,
            pageLevel: PAGE_LEVEL.SECOND
          }
        },
        {
          path: 'compliance-recording-files',
          name: 'complianceRecordingFiles',
          component: () =>
            import(
              /* webpackChunkName: 'compliance-recording-files' */ '@/pages/selfhelp/compliance/recordingFiles.vue'
            ),
          meta: {
            name: 'routers.meeting_personal_recording',
            parent: '/self-help/meeting/mine',
            // otherParent: ['/self-help/meeting/compliance/employee', '/self-help/meeting/history'],
            pageLevel: PAGE_LEVEL.SECOND
          }
        },
        {
          path: 'compliance-recording-files/detail',
          name: 'complianceRecordingFilesDetail',
          component: () => import(/* webpackChunkName: 'compliance-recording-files-detail' */ '@/pages/voice/detail'),
          meta: {
            name: 'routers.meeting_detail',
            parent: '/self-help/meeting/mine',
            otherParent: ['/self-help/meeting/history'],
            pageLevel: PAGE_LEVEL.THIRD
          }
        }
      ]
    }
  ]
};
